// extracted by mini-css-extract-plugin
export default {"page":"styles_page__XKrI3","ca":"styles_ca__1r7x3","ad":"styles_ad__NanOs"};